import AppDevice from "../../Class/device"

export async function acceso(token){
    //console.log(token)
    let reqext = await fetch(`${AppDevice.ServerUrl}/visorexterno/${token}`)
    let resext = await reqext.json()
    console.log(resext)
    return(resext)
}